// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as fetchGetAllDisciplineInfoReducer } from './fetchGetAllDisciplineInfo';
import { reducer as fetchGetStuCourseListReducer } from './fetchGetStuCourseList';
import { reducer as fetchCourseDetailReducer } from './fetchCourseDetail';
import { reducer as fetchGetRecommendCourseReducer } from './fetchGetRecommendCourse';
import { reducer as fetchGetRelationCourseReducer } from './fetchGetRelationCourse';
import { reducer as fetchGetCourseChapterReducer } from './fetchGetCourseChapter';
import { reducer as fetchGetIsOrderReducer } from './fetchGetIsOrder';
import { reducer as fetchGetCourseCommentReducer } from './fetchGetCourseComment';
import { reducer as fetchUpdateThumpUpReducer } from './fetchUpdateThumpUp';
import { reducer as fetchAddCommentReducer } from './fetchAddComment';
import { reducer as fetchGetCourseDocReducer } from './fetchGetCourseDoc';
import { reducer as fetchAddCollectionReducer } from './fetchAddCollection';
import { reducer as fetchGetStuCoursePackListReducer } from './fetchGetStuCoursePackList';
import { reducer as fetchCoursePackDetailReducer } from './fetchCoursePackDetail';
import { reducer as fetchDirectOrderReducer } from './fetchDirectOrder';
import { reducer as fetchUnifiedCreateOrderReducer } from './fetchUnifiedCreateOrder';
import { reducer as fetchGetWConfigurationReducer } from './fetchGetWConfiguration';
import { reducer as fetchGetVideoReducer } from './fetchGetVideo';
import { reducer as fetchGetVideoTokenReducer } from './fetchGetVideoToken';
import { reducer as fetchAddAnswerReducer } from './fetchAddAnswer';
import { reducer as fetchGetAnswerListReducer } from './fetchGetAnswerList';
import { reducer as fetchSaveVideoLookReducer } from './fetchSaveVideoLook';
import { reducer as fetchGetDisciplineInfoByCourseReducer } from './fetchGetDisciplineInfoByCourse';
import { reducer as fetchInputToCookiesReducer } from './fetchInputToCookies';
import { reducer as fetchGetSetlistReducer } from './fetchGetSetlist';
import { reducer as fetchGetHaveCourseListDisciplineReducer } from './fetchGetHaveCourseListDiscipline';
import { reducer as fetchGetCourseAndPackageListReducer } from './fetchGetCourseAndPackageList';
import { reducer as fetchStudentShowCouponListReducer } from './fetchStudentShowCouponList';
import { reducer as fetchStudentGetCouponReducer } from './fetchStudentGetCoupon';
import { reducer as fetchGetCouponCourseListReducer } from './fetchGetCouponCourseList';
import { reducer as fetchGetCourseCouponReducer } from './fetchGetCourseCoupon';
import { reducer as fetchGetVideoLogoReducer } from './fetchGetVideoLogo';

const reducers = [
  fetchGetAllDisciplineInfoReducer,
  fetchGetStuCourseListReducer,
  fetchCourseDetailReducer,
  fetchGetRecommendCourseReducer,
  fetchGetRelationCourseReducer,
  fetchGetCourseChapterReducer,
  fetchGetIsOrderReducer,
  fetchGetCourseCommentReducer,
  fetchUpdateThumpUpReducer,
  fetchAddCommentReducer,
  fetchGetCourseDocReducer,
  fetchAddCollectionReducer,
  fetchGetStuCoursePackListReducer,
  fetchCoursePackDetailReducer,
  fetchDirectOrderReducer,
  fetchUnifiedCreateOrderReducer,
  fetchGetWConfigurationReducer,
  fetchGetVideoReducer,
  fetchGetVideoTokenReducer,
  fetchAddAnswerReducer,
  fetchGetAnswerListReducer,
  fetchSaveVideoLookReducer,
  fetchGetDisciplineInfoByCourseReducer,
  fetchInputToCookiesReducer,
  fetchGetSetlistReducer,
  fetchGetHaveCourseListDisciplineReducer,
  fetchGetCourseAndPackageListReducer,
  fetchStudentShowCouponListReducer,
  fetchStudentGetCouponReducer,
  fetchGetCouponCourseListReducer,
  fetchGetCourseCouponReducer,
  fetchGetVideoLogoReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/course/redux/reducer.js